import request from '@/utils/request'
// 获取广告列表
export function getAdList(params) {
  return request({
    url: 'api/z/ad/getAdList',
    method: 'post',
    params
  })
}
// 收藏中心- 用户收藏店铺/商品
export function collectThings(params) {
  return request({
    url: 'memberCollect/collect',
    method: 'post',
    params
  })
}
// 客户服务模块-获取商品订单
export function getAfterOrderList(params) {
  return request({
    url: 'after/sales/orderlist',
    method: 'get',
    params
  })
}
// 客户服务模块-获取退换货记录
export function getAfterRecordList(params) {
  return request({
    url: 'after/sales/record',
    method: 'get',
    params
  })
}
// 客户服务模块-获取售后申请页面内的商品详情
export function getAfterItemDetail(params) {
  return request({
    url: 'after/sales/item',
    method: 'get',
    params
  })
}
// 客户服务模块-获取售后申请页面内的商品详情
export function getAfterApplyItemDetail(params) {
  return request({
    url: 'after/sales/applyitem',
    method: 'get',
    params
  })
}
// 客户服务模块-售后申请
export function getAfterApply(data) {
  return request({
    url: 'after/sales/apply',
    method: 'put',
    data
  })
}

/**
 * 买家发货
 * @param data
 * @returns {*}
 */
export function updateFregist(data) {
  return request({
    url: 'after/sales/updateFregist',
    method: 'put',
    data
  })
}
// 全部退货原因
export function getReturnReason(params) {
  return request({
    url: 'api/z/list/all',
    method: 'get',
    params
  })
}
// 客户服务模块-取消售后申请
export function cancelAfterApply(params) {
  return request({
    url: 'after/sales/cancel',
    method: 'put',
    params
  })
}
// 客户服务模块-获取服务单详情
export function getSericeDetail(params) {
  return request({
    url: 'after/sales/detail',
    method: 'get',
    params
  })
}

//
export function messageGetmessage(params) {
  return request({
    url: 'message/getmessage',
    method: 'GET',
    params
  })
}
//
export function messageSetmessage(data) {
  return request({
    url: 'message/setmessage',
    method: 'POST',
    data
  })
}
// 账号设置
// 显示所有收货地址
export function getAddressList(params) {
  return request({
    url: 'member/address/list',
    method: 'get',
    params
  })
}
//省市区三级联动
export function getArea(params) {
  return request({
    url: 'api/z/area/getArea',
    method: 'get',
    params
  })
}
//添加收货地址
export function addAddress(data) {
  return request({
    url: 'member/address/add',
    method: 'post',
    data
  })
}
// 删除收货地址
export function deleteAddress(data) {
  return request({
    url: `member/address/delete/${data}`,
    method: 'post',
    data
  })
}
// 根据地址id设置默认地址
export function setDefaultAddress(params) {
  return request({
    url: `member/address/setDefault/${params}`,
    method: 'get',
    params
  })
}
// 根据地址id查询地址
export function getAddressDetail(params) {
  return request({
    url: `member/address/${params}`,
    method: 'get',
    params
  })
}
// 修改收货地址
export function updateAddress(data) {
  return request({
    url: `member/address/update/${data.id}`,
    method: 'post',
    data
  })
}
// 会员首页
export function accountHome(params) {
  return request({
    url: 'account/home',
    method: 'get',
    params
  })
}
//
export function messageGetDetail(params) {
  return request({
    url: 'message/getDetail',
    method: 'get',
    params
  })
}
// 根据一级分类id获取文章列表
export function getArticleList(params) {
  return request({
    url: 'article/list',
    method: 'get',
    params
  })
}
// 根据级别分类id获取文章列表
export function getLeverlArticleList(params) {
  return request({
    url: 'api/z/articleList',
    method: 'get',
    params
  })
}
// 文章点赞
export function getLikeArticle(params) {
  return request({
    url: 'article/like',
    method: 'put',
    params
  })
}
// 获取文章详情
export function getArticleDetail(params) {
  return request({
    url: 'article/detail',
    method: 'get',
    params
  })
}
// 会员浏览记录
export function getReadHistory(params) {
  return request({
    url: 'api/y/member/readHistory/list',
    method: 'post',
    params
  })
}
// 会员首页浏览记录
export function getReadHomeHistory(params) {
  return request({
    url: '/api/y/member/readHistory/homelist',
    method: 'post',
    params
  })
}

// 删除浏览记录
export function deleteReadHistory(params) {
  return request({
    url: 'api/y/member/readHistory/delete',
    method: 'post',
    params
  })
}
// 创建浏览记录
export function createReadHistory(params) {
  return request({
    url: 'api/y/member/readHistory/create',
    method: 'post',
    params
  })
}
// 会员实名认证申请
export function getVerified(data) {
  return request({
    url: 'sso/verified',
    method: 'post',
    data
  })
}
// 返回当前登录用户实名审核消息
export function getReviewMessage(params) {
  return request({
    url: 'sso/reviewMessage',
    method: 'get',
    params
  })
}
// 会员等级列表
export function memberLevelList(params) {
  return request({
    url: 'memberLevels',
    method: 'get',
    params
  })
}
// 升级会员等级
export function upgradeMemberLevel(data) {
  return request({
    url: 'memberLevels/upgrade',
    method: 'post',
    data
  })
}
// 领取指定优惠券
export function getCoupon(data) {
  return request({
    url: `member/coupon/add/${data}`,
    method: 'post',
    data
  })
}
// 获取店铺设置连接参数
export function shopSettings(params) {
  return request({
    url: `account/shopSettings`,
    method: 'get',
    params
  })
}
// 会员积分管理
export function integralGetIntegral(params) {
  return request({
    url: 'integral/getIntegral',
    method: 'GET',
    params
  })
}
//
export function getIntegralList(params) {
  return request({
    url: 'integral/getIntegralList',
    method: 'GET',
    params
  })
}
// 优惠券列表
export function memberCouponList(params) {
  return request({
    url: 'member/coupon/list',
    method: 'GET',
    params
  })
}
// 优惠券删除
export function memberCoupon(params, id) {
  return request({
    url: 'member/coupon/' + id,
    method: 'DELETE',
    params
  })
}
// 提现列表
export function financeSelectList(params) {
  return request({
    url: 'finance/selectList',
    method: 'GET',
    params
  })
}
// 申请提现
export function financeAdd(data) {
  return request({
    url: 'finance/add',
    method: 'POST',
    data
  })
}
// 付款账户信息
export function financeGetPayment(params) {
  return request({
    url: 'finance/getPayment',
    method: 'GET',
    params
  })
}
// 验证可提现金额
export function userAccountInfo(params) {
  return request({
    url: 'account',
    method: 'GET',
    params
  })
}
// 修改售后订单
export function salesUpdate(data) {
  return request({
    url: 'after/sales/update',
    method: 'PUT',
    data
  })
}
// 网店助手 => 授权网店列表
export function onlineStoreList(params) {
  return request({
    url: 'online/store/list',
    method: 'GET',
    params
  })
}
//
export function storeAuthorization(params) {
  return request({
    url: 'online/store/authorization',
    method: 'GET',
    params
  })
}
//
export function onlineStoreListdmcht(params) {
  return request({
    url: 'online/store/dmcht/list',
    method: 'GET',
    params
  })
}
//
export function webShop(params) {
  return request({
    url: 'web/shop',
    method: 'GET',
    params
  })
}
// 获取分销商申请记录
export function getDMchtList(params) {
  return request({
    url: 'dmcht/list',
    method: 'get',
    params
  })
}
// 分销商申请
export function applyDMcht(data) {
  return request({
    url: 'dmcht/apply',
    method: 'put',
    data
  })
}
// 一键上传 铺货
export function uploadGoods(params) {
  return request({
    url: 'youzan/product/put',
    method: 'put',
    params
  })
}
// 判断用户是否与指定供应商分销关系
export function isDistributor(params) {
  return request({
    url: 'online/store/history',
    method: 'get',
    params
  })
}

export function financeVerification(params) {
  return request({
    url: 'finance/verification',
    method: 'get',
    params
  })
}

export function financeGetHandlingFee(params) {
  return request({
    url: 'finance/getHandlingFee',
    method: 'get',
    params
  })
}
